<template>
  <div class="pay-panel">

    <div class="content">
      <div class="merchant-row">
        <div class="merchant-avatar" style="display: flex;align-items: center;justify-content: center;">
          <img :src="avatar ? avatar : icon_member_default" alt="" />
        </div>
        <div class="merchant-name">{{ merchantName }}</div>
      </div>

      <div class="amount-card">
        <div class="amount-label">付款金额</div>
        <div class="amount-line">
          <span class="amount-symbol">￥</span>
          <div class="input-c">
            <div class="input-c-div-1">{{ formatMoney(amount) }}</div>
            <div class="input-c-div" :style="'background:' + typeColor[payType] + ';border-color:' + typeColor[payType] + ';'"></div>
          </div>
        </div>
        <div class="remark-input" @click="myDialogStateFn(remark)">
          <span v-if="remark">{{ remark }}</span>
          <span v-else>添加备注</span>
        </div>
      </div>

      <div class="brand-logo">
        <img
          class="brand-logo-img"
          src="https://agent.fskeeper.com/img/乘鱼掌柜（黑色字体）.png"
          alt="乘鱼掌柜"
        />
      </div>
    </div>
    <MyDialog
        v-show="myDialogState"
        @myDialogStateFn="myDialogStateFn"
        :remark="remark"
        :typeColor="typeColor[payType]"
    >
    </MyDialog>

    <div class="keyboard-plus" v-if="isAllowModifyAmount">
      <Keyboard
          @delTheAmount="delTheAmount"
          @conceal="conceal"
          @enterTheAmount="enterTheAmount"
          @clearTheAmount="clearTheAmount"
          @payment="payment"
          @paymentAndInvoice="paymentAndInvoice"
          :money="money"
          :concealSate="concealSate"
          :typeColor="typeColor[payType]"
          :touchTypeColor="touchTypeColor[payType]"
          :invoiceEnabled="invoiceEnabled"
      ></Keyboard>
    </div>

    <div class="bnt-pay" v-if="!isAllowModifyAmount">
      <div class="bnt-pay-group">
        <div
            class="bnt-pay-text"
            :style="'background:' + typeColor[payType] + ';'"
            @click="pay"
        >
          付款
        </div>
        <div
            v-if="invoiceEnabled"
            class="bnt-pay-text-outline"
            :style="'color:' + typeColor[payType] + ';border-color:' + typeColor[payType] + ';'"
            @click="payAndInvoice"
        >
          付款+开票
        </div>
      </div>
    </div>

    <div v-if="paying" class="pay-loading-mask">
      <div class="pay-loading-box">
        <div class="pay-loading-spinner" :style="'border-top-color:' + typeColor[payType] + ';'"></div>
        <div class="pay-loading-text">处理中...</div>
      </div>
    </div>
  </div>
</template>

<script>
import MyDialog from "@/views/dialog/dialog";
import Keyboard from "@/views/keyboard/keyboard";
import { getPayPackage, getPayOrderInfo, getMyTransactions } from '@/api/api'
import config from "@/config";
import wayCodeUtils from '@/utils/wayCode'
export default {
  components: { MyDialog, Keyboard },
  data: function (){
    return {
      merchantName: '乘鱼掌柜',
      avatar: require("../../assets/images/ysf.jpg"),
      amount: "",
      resData : {},
      payImg: require("../../assets/images/ysf.jpg"),
      payOrderInfo: {},
      isAllowModifyAmount: true,
      myDialogState: false,
      remark: "",
      money: -1,
      concealSate: true,
      paying: false,
      debugInfo: "",
      payType: "ysfpay",
      invoiceEnabled: false,
      fromInvoice: false,
      invoiceList: [],
      transactionList: [],
      showInvoiceList: false,
      showTransactionList: false,
      // 商户推广引流：抖音/快手/小红书链接拼接文案，下单（点付款手势）时复制到剪贴板
      promoCopyText: '',
      typeColor: {
        alipay: "#1678ff",
        wxpay: "#07c160",
        ysfpay: "#ff534d"
      },
      touchTypeColor: {
        alipay: "rgba(20, 98, 206, 1)",
        wxpay: "rgba(7, 130, 65, 1)",
        ysfpay: "rgb(248 70 65, 1)"
      },
    }
  },
  mounted() {
    this.fromInvoice = this.$route.query.fromInvoice === '1';
    this.loadInvoiceRecords();
    this.fetchMyTransactions();
    this.setPayOrderInfo();
  },
  methods: {
    loadInvoiceRecords() {
      this.invoiceList = JSON.parse(sessionStorage.getItem('invoiceRecords') || '[]');
      if (this.invoiceList.length > 0) this.showInvoiceList = true;
    },
    fetchMyTransactions() {
      const that = this;
      getMyTransactions(50).then(list => {
        that.transactionList = Array.isArray(list) ? list : [];
        if (that.transactionList.length > 0) that.showTransactionList = true;
      }).catch(() => {
        that.transactionList = [];
      });
    },
    formatTxnYuan(amountFen) {
      if (amountFen == null || amountFen === '') return '0.00';
      const n = Number(amountFen);
      if (isNaN(n)) return String(amountFen);
      return (n / 100).toFixed(2);
    },
    formatTxnTime(item) {
      const raw = item.successTime || item.createdAt || item.createTime;
      if (!raw) return '';
      const d = new Date(raw);
      if (isNaN(d.getTime())) return String(raw);
      return d.getFullYear() + '-' +
          String(d.getMonth() + 1).padStart(2, '0') + '-' +
          String(d.getDate()).padStart(2, '0') + ' ' +
          String(d.getHours()).padStart(2, '0') + ':' +
          String(d.getMinutes()).padStart(2, '0');
    },
    payment() {
      if (this.money == -1)
        return;
      this.pay();
    },
    paymentAndInvoice() {
      if (this.money == -1)
        return;
      this.goInvoicePage();
    },
    conceal() {
      this.concealSate = !this.concealSate
    },
    enterTheAmount(item) {
      if (this.amount >= 9999999
          || (item === "." && this.amount.includes("."))
          || (this.amount.includes(".") && this.amount.split(".").pop().length >= 2)
      ) {
        return;
      }
      if (this.amount === "0") {
        this.amount = item.toString();
      } else {
        this.amount = `${this.amount}${item}`;
      }
      if (this.amount === ".") {
        this.amount = "0.";
      }
      if (!Number.isNaN(this.amount)) {
        this.payOrderInfo.amount = this.amount * 100;
      } else {
        this.payOrderInfo.amount = 0;
      }
      this.money = this.payOrderInfo.amount > 0 ? this.payOrderInfo.amount : -1;
    },
    delTheAmount() {
      this.amount = this.amount.substring(0, this.amount.length - 1)
      if (!Number.isNaN(this.amount)) {
        this.payOrderInfo.amount = this.amount * 100;
      } else {
        this.payOrderInfo.amount = 0;
      }
      this.money = this.payOrderInfo.amount > 0 ? this.payOrderInfo.amount : -1;
    },
    clearTheAmount(){
      this.amount = "";
      this.payOrderInfo.amount = 0;
      this.money = -1;
    },
    formatMoney(money) {
      let part = money.toString().split('.');
      let l = part[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      let r = part.length > 1 ? `.${part.pop()}` : '';
      return `${l}${r}`
    },
    myDialogStateFn: function (remark) {
      this.remark = remark;
      this.myDialogState = !this.myDialogState;
    },
    setPayOrderInfo(){
      const that = this
      getPayOrderInfo().then(res => {
        that.payOrderInfo = res
        that.merchantName = res.mchName
        that.promoCopyText = that.buildPromoCopyText(res.promotion)
        that.amount = Number(res.amount) > 0 ? (res.amount / 100) + "" : ""
        that.money = this.payOrderInfo.amount > 0 ? this.payOrderInfo.amount : -1
        that.isAllowModifyAmount = res.fixedFlag !== 1
        that.invoiceEnabled = !!res.invoiceEnabled
        if (res.payOrderId && !that.fromInvoice) {
          const fixedRoute = wayCodeUtils.getFixedRouteName()
          if (fixedRoute) {
            that.$router.replace({ name: fixedRoute })
          }
          return
        }
      }).catch(res => {
        that.$router.push({name: config.errorPageRouteName, params: {errInfo: res.msg}})
      });
    },
    payAndInvoice: function () {
      this.goInvoicePage();
      // window.location.href = 'https://qr.95516.com/UP02/qrcGtwWeb-web/front/confirmOrder?sessionId=b913af40b68342baa16cc7e292c10313';
    },
    goInvoicePage() {
      this.$router.push({
        name: 'CashierInvoice',
        query: { amount: this.amount, payType: this.payType, remark: this.remark }
      });
    },
    buildPromoCopyText(promo) {
      if (!promo) return '';
      const parts = [];
      if (promo.douyinVideoUrl) parts.push('抖音：' + promo.douyinVideoUrl);
      if (promo.kuaishouVideoUrl) parts.push('快手：' + promo.kuaishouVideoUrl);
      if (promo.xiaohongshuVideoUrl) parts.push('小红书：' + promo.xiaohongshuVideoUrl);
      return parts.join('\n');
    },
    copyToClipboard(text) {
      if (!text) return Promise.resolve();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).catch(() => this.fallbackCopy(text));
      }
      return Promise.resolve(this.fallbackCopy(text));
    },
    fallbackCopy(text) {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) { /* ignore */ }
      document.body.removeChild(ta);
    },
    pay: function () {
      if (this.paying) return;
      let that = this;
      this.paying = true;
      that.debugInfo = '正在请求支付...';
      // 在用户点击「付款」的手势上下文中复制推广链接（此时剪贴板写入最可靠），
      // 支付完成后用户即可直接到抖音/快手/小红书粘贴打开。
      if (this.promoCopyText) {
        this.copyToClipboard(this.promoCopyText);
      }
      getPayPackage(this.amount, this.remark).then(res => {
        that.paying = false;
        that.debugInfo = '响应: ' + JSON.stringify(res);
        if (res.code && res.code != '0') {
          that.debugInfo += ' | 错误: code=' + res.code;
          return;
        }
        if (res.orderState != 1) {
          that.debugInfo += ' | 订单状态异常: ' + res.orderState;
          return;
        }
        if (res.redirectUrl) {
          that.debugInfo += ' | 即将跳转: ' + res.redirectUrl;
          setTimeout(function() {
            window.location.href = res.redirectUrl;
          }, 1500);
        } else {
          that.debugInfo += ' | redirectUrl为空!';
        }
      }).catch(res => {
        that.paying = false;
        that.debugInfo = 'catch错误: ' + JSON.stringify(res);
      });
    },
  }
}
</script>
<style lang="css" scoped>
@import './pay.css';

.pay-loading-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.pay-loading-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  padding: 28px 36px;
  gap: 14px;
}
.pay-loading-spinner {
  width: 36px;
  height: 36px;
  border: 4px solid #e0e0e0;
  border-top-color: #ff534d;
  border-radius: 50%;
  animation: pay-spin 0.8s linear infinite;
}
.pay-loading-text {
  font-size: 14px;
  color: #555;
}
@keyframes pay-spin {
  to { transform: rotate(360deg); }
}
</style>
